module.exports = __webpack_public_path__ + "img/3.99a60065.png";